'use client';

import { RateLimitError } from '@/lib/rate-limit-error';

/** JSON body from GET `/api/portfolio/[address]` (shared cache shape). */
export type PortfolioApiJson = {
  data?: any;
  takeoverPriceUsd?: number;
  [key: string]: unknown;
} | null;

/**
 * Raw portfolio GET — same JSON as `/api/portfolio/[address]` for React Query cache.
 */
export async function fetchPortfolioJson(address: string): Promise<PortfolioApiJson> {
  try {
    const path = encodeURIComponent(address.toLowerCase());
    const res = await fetch(`/api/portfolio/${path}`);
    if (res.status === 429) throw new RateLimitError();
    if (!res.ok) return null;
    return (await res.json()) as PortfolioApiJson;
  } catch (e) {
    if (e instanceof RateLimitError) throw e;
    return null;
  }
}
